import { IonButton } from "@ionic/react";
import React from "react";
import "./StyledButton.css";

const StyledButton = (props) => {
  return <IonButton {...props} />;
};

export default StyledButton;
